import { render, staticRenderFns } from "./SummaryOverview.html?vue&type=template&id=2b1ffe71&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryOverview.scss?vue&type=style&index=0&id=2b1ffe71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ffe71",
  null
  
)

export default component.exports